import { Blockquote as MantineBlockquote, BlockquoteProps, useMantineTheme } from '@mantine/core';
import { forwardRef } from 'react';

export type GradientVariant =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'success'
  | 'info'
  | 'warning'
  | 'danger';

export interface ThemedBlockquoteProps extends BlockquoteProps {
  gradient?: boolean;
  gradientVariant?: GradientVariant;
}

const Blockquote = forwardRef<HTMLQuoteElement, ThemedBlockquoteProps>(
  ({ gradient = false, gradientVariant = 'primary', ...rest }, ref) => {
    const theme = useMantineTheme();

    if (!gradient) {
      return <MantineBlockquote ref={ref} {...rest} />;
    }

    const grad = theme.other.gradients[gradientVariant];

    return (
      <MantineBlockquote
        ref={ref}
        styles={{
          root: {
            borderLeftWidth: 4,
            borderImage: `linear-gradient(180deg, ${grad.from}, ${grad.to}) 1`,
          },
          icon: {
            backgroundImage: `linear-gradient(135deg, ${grad.from}, ${grad.to})`,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
          },
        }}
        {...rest}
      />
    );
  }
);

Blockquote.displayName = 'Blockquote';

export default Blockquote;
